var _rect, _rect2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLevel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 1.27539,
    width: 20.7246,
    height: 20.7246,
    rx: 10.3623,
    fill: "#AD1362"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 20.7246,
    height: 20.7246,
    rx: 10.3623,
    fill: "#E551B4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.80629 14.0146V7.48479L6.52049 8.199H4.37788V6.87262H7.45916V14.0146H5.80629Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9051 14.9856C13.3736 14.9856 14.5641 13.7675 14.5641 12.2654C14.5641 11.9916 14.5024 11.3675 14.2548 11.064L14.6258 10.6844C14.8442 10.461 14.9084 10.5213 15.014 10.6207C15.0584 10.662 15.1095 10.7102 15.1826 10.7477C15.1826 10.7477 15.6152 11.064 16.0482 10.7477C16.2953 10.5579 16.6413 10.0263 16.0482 9.41939L16.1715 9.29285C16.1715 9.29285 16.6046 9.67205 17.0376 9.35612C17.2847 9.1663 17.5319 8.66012 17.0993 8.21721L17.5319 7.77474C17.8289 7.47086 17.6556 7.09983 17.5319 6.95262L17.1609 6.57256C16.8145 6.21832 16.4394 6.42492 16.2949 6.57256L13.08 9.86187C13.08 9.86187 12.5857 9.5455 11.9055 9.5455C10.4371 9.5455 9.24658 10.7636 9.24658 12.2658C9.24658 13.768 10.4371 14.9856 11.9051 14.9856ZM12.8328 12.2658C12.8333 12.5169 12.7359 12.7578 12.562 12.9357C12.3881 13.1136 12.152 13.2139 11.9055 13.2144C11.7835 13.2142 11.6627 13.1895 11.55 13.1417C11.4373 13.0939 11.335 13.024 11.2488 12.9359C11.1627 12.8478 11.0944 12.7433 11.0479 12.6283C11.0014 12.5133 10.9776 12.3901 10.9778 12.2658C10.9776 12.1414 11.0014 12.0183 11.0479 11.9033C11.0944 11.7883 11.1627 11.6838 11.2488 11.5957C11.335 11.5076 11.4373 11.4377 11.55 11.3899C11.6627 11.3421 11.7835 11.3174 11.9055 11.3171C12.152 11.3177 12.3881 11.418 12.562 11.5959C12.7359 11.7737 12.8333 12.0147 12.8328 12.2658Z",
    fill: "#FFCE63"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevel);
export default __webpack_public_path__ + "static/media/Level.541853c04bb48b59e6b2.svg";
export { ForwardRef as ReactComponent };